import { Component, OnInit, ViewChild, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FileUploaderComponent } from '../file-uploader/file-uploader.component';
import { disclaimer, getStringSizeInBytes, MAIL_SIGNATURE, maxMailSizeMB } from '../../shared/constants';
import { MailListComponent } from '../mail-list/mail-list.component';
import { NavbarComponent } from '../../navbar/navbar.component';
import { Config } from 'datatables.net';
declare const $: any;

@Component({
	selector: 'app-view-mail',
	templateUrl: './view-mail.component.html',
	styleUrls: ['./view-mail.component.scss', '../../../assets/styles/mailbox.scss']
})
export class ViewMailComponent implements OnInit {
	@ViewChild('fileUploaderComponent') fileUploaderComponent!: FileUploaderComponent;
	form: FormGroup = this.formBuilder.group({
		mail: [null]
	});
	attachment: any[] = [];
	mailId: any;
	viewMail: any;
	folder = "";
	moduleAccess: any;
	replymoduleAccess: any;
	spammoduleAccess: any;
	mailFoldermoduleAccess: any;
	isReply = false;
	mailSignature = MAIL_SIGNATURE;
	showMailLoader = false;
	apptId: any = null;
	followUpId: any = null;
	apptList: any = [];
	loaderMoveMail = false;
	mailboxReadonly = true;

	constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private apiService: ApiService, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(MailListComponent) public mailListComp: MailListComponent, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) {
		if (localStorage.getItem('usertype') == "Company") {
			this.mailboxReadonly = true;
		} else {
			this.mailboxReadonly = false;
		}
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.activeRoute.parent?.params.subscribe(params => {
				this.folder = params["folder"] == undefined ? "" : params["folder"];
			});
			this.mailId = routeParams["mailId"];
			let url = this.router.url;
			if (url.indexOf("app/appt-details") >= 0) {
				let segmentList = url.split("/");
				this.apptId = segmentList[4];
				try {
					if (this.apptId) {
						this.apptId = decodeURIComponent(this.apptId);
					}
				} catch (e) { }
				this.followUpId = segmentList[5];
				try {
					if (this.followUpId) {
						this.followUpId = decodeURIComponent(this.followUpId);
					}
				} catch (e) { }

			} else {
				this.apptId = "";
				this.followUpId = "";
			}
			this.moduleAccess = "Full";
			this.replymoduleAccess = "Full";
			this.spammoduleAccess = "Full";
			this.mailFoldermoduleAccess = "Full";
			this.isReply = false;
			this.getMailDetails();
		});
		this.apiService.userData$.subscribe((user) => {
			if (user) {
				this.mailSignature = user.email_signature || MAIL_SIGNATURE;
			}
		})
	}

	getMailDetails() {
		this.viewMail = null;
		this.showMailLoader = true;
		this.apiService.getMails({ id: this.mailId }).subscribe({
			next: (data: any) => {
				this.showMailLoader = false;
				this.viewMail = data;
				this.mailStatusSet();
				if (this.apptId && this.viewMail.email_status == "draft") {
					this.apiService.setMailSelect(this.apptId);
				}
			}, error: (error) => {
				this.showMailLoader = false;
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showReply() {
		this.isReply = true;
		const mail: any = this.bindCommonInputs();
		mail.body = this.mailSignature;
		if (this.viewMail?.email_status == 'read' || this.viewMail?.email_status == 'unread') {
			mail.toMail.push(this.viewMail.from_email);
		}
		if (this.viewMail.from_email !== null) {
			let emailExists = false;
			for (var i = 0; i < mail.toMail.length; i++) {
				if (mail.toMail[i] == this.viewMail.from_email) {
					emailExists = true;
				}
			}
			if (!emailExists) {
				mail.toMail.push(this.viewMail.from_email.trim());
			}
		}
		for (var i = 0; i < mail.toMail.length; i++) {
			if (mail.toMail[i] == environment.email_id) {
				mail.toMail.splice(i, 1);
				break;
			}
		}
		this.form.get('mail')?.patchValue(mail);
	}

	bindCommonInputs() {
		const mail: any = {};
		mail.subject = this.viewMail.subject;
		mail.ccMail = [];
		if (this.viewMail.ccArr && this.viewMail.ccArr.length > 0) {
			for (var i = 0; i < this.viewMail.ccArr.length; ++i) {
				mail.ccMail.push(this.viewMail.ccArr[i]);
			}
		}
		mail.toMail = [];
		if (this.viewMail.toMailArr && this.viewMail.toMailArr.length > 0) {
			for (var i = 0; i < this.viewMail.toMailArr.length; i++) {
				mail.toMail.push(this.viewMail.toMailArr[i]);
			}
		}
		return mail;
	}

	mail_html_fetched(mail: any) {
		this.viewMail = mail;
		if (this.viewMail.email_status == "draft") {
			const mail: any = this.bindCommonInputs();
			this.attachment = this.viewMail.attachmentsArr;
			mail.body = this.viewMail["draft_body"];
			this.form.get('mail')?.patchValue(mail);
		}
	}

	mailStatusSet() {
		if (this.viewMail.email_status === "unread") {
			this.apiService.mailStatusChange(this.mailId).subscribe({ next: (data) => { }, error: (error) => { } });
		}
	}

	linkMails() {
		Swal.fire({
			title: 'Warning',
			text: "Are you sure you want to link this mail?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				this.router.navigate(['/app/list-appointment'], {
					queryParams: { mails: this.viewMail.id }
				});
			}
		})
	}

	unlinkMails() {
		Swal.fire({
			title: 'Warning',
			text: "Are you sure you want to unlink this mail?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				let payload: any = {
					"mail_ids": [this.viewMail.id],
					"event_id": atob(this.apptId)
				};
				this.showMailLoader = true;
				this.apiService.unlinkMail(payload).subscribe({
					next: (data: any) => {
						this.showMailLoader = false;
						this.toastr.success("Mail unlinked successfully.", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						if (this.apptId) {
							this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
						} else {
							this.router.navigate(['/app/mailbox/folder/' + this.folder]);
							/* this.mailListComp.refreshMails(true); */
						}
						setTimeout(() => {
							this.apiService.sendCountChangeEvent();
						}, 100);
					}, error: (error: any) => {
						this.showMailLoader = false;
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	openMoveMailModal() {
		var msg = "Are you sure you want to mark selected mail as ";
		this.viewMail.spam ? msg += "<strong>not spam</strong>?" : msg += "<strong>spam</strong>?";
		Swal.fire({
			title: 'Please confirm',
			html: msg,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes'
		}).then((result) => {
			if (result.value) {
				let data: any = {
					"mail_ids": [this.viewMail.id],
					"spam": !this.viewMail.spam
				}
				this.loaderMoveMail = true;
				this.apiService.changeSpamStatus(data).subscribe({
					next: (data) => {
						this.loaderMoveMail = false;
						this.toastr.info(data.toString(), 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						if (this.apptId) {
							this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
						} else {
							const endpoint = this.viewMail.spam ? "unlinked" : "spam";
							this.router.navigate(['/app/mailbox/folder/' + endpoint]);
						}
						setTimeout(() => {
							this.apiService.sendCountChangeEvent();
						}, 100);
					}, error: (error) => {
						this.loaderMoveMail = false;
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	discardDraft() {
		Swal.fire({
			title: '',
			text: 'Are you sure you want discard draft?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Discard'
		}).then((result) => {
			if (result.value) {
				this.apiService.deleteMail({ id: [this.viewMail.id] }).subscribe({
					next: (data) => {
						this.toastr.info(data.toString(), 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						if (this.apptId) {
							this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
						} else {
							this.router.navigate(['/app/mailbox/folder/draft']);
							/* this.mailListComp.refreshMails(true); */
						}
						setTimeout(() => {
							this.apiService.sendCountChangeEvent();
						}, 100);
					}, error: (error) => {
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	saveMail(action: string) {
		let err: String[] = [];
		if (!this.form.value.mail.toMail || !this.form.value.mail.toMail.length) {
			err.push("To");
		}
		if (!this.form.value.mail.subject) {
			err.push("Subject");
		}
		if (!this.form.value.mail.body) {
			err.push("Body");
		}
		if (err.length) {
			this.toastr.info("Please provide " + err.join(", "), 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let attachment = this.fileUploaderComponent.getAttachments();
		let cc: any = this.form.value.mail.ccMail;
		if (cc == null) {
			cc = [];
		}
		let mailContent = this.form.value.mail.body;
		const container = document.createElement('div');
		container.innerHTML = mailContent;
		const cells = container.querySelectorAll('th, td');
		cells.forEach((cell) => {
			if (cell instanceof HTMLElement) {
				cell.style.border = '1px solid black';
			}
		});
		mailContent = container.innerHTML;
		let mailObj: any = {};
		mailObj["to"] = JSON.stringify(this.form.value.mail.toMail);
		mailObj["cc"] = JSON.stringify(cc);
		mailObj["subject"] = this.form.value.mail.subject;
		mailObj["attachment"] = JSON.stringify(this.attachment.concat(attachment));
		let successMsg = "";
		let pathAfterSuccess = "";
		if (action == "update_draft") {
			mailObj["id"] = this.viewMail.id;
			mailObj["reply_id"] = this.viewMail.reply_id;
			mailObj["email_status"] = "draft";
			if (this.viewMail.reply_id) {
				mailObj["content"] = mailContent + '<span id="mailSeparator" style="display:none;"></span>' + this.viewMail.body_html;
			} else {
				mailObj["content"] = mailContent;
			}
			successMsg = "Draft updated successfully";
			pathAfterSuccess = "draft";
		} else if (action == "compose_mail") {
			mailObj["id"] = this.viewMail.id;
			mailObj["reply_id"] = this.viewMail.reply_id;
			mailObj["email_status"] = "sent";
			if (this.viewMail.reply_id) {
				mailObj["content"] = mailContent + '<span id="mailSeparator" style="display:none;"></span>' + this.viewMail.body_html + disclaimer;
			} else {
				mailObj["content"] = mailContent + disclaimer;
			}
			successMsg = "Mail sent successfully";
			pathAfterSuccess = "outgoing";
		} else if (action == "save_reply_draft") {
			mailObj["reply_id"] = this.viewMail.id;
			mailObj["email_status"] = "draft";
			mailObj["content"] = mailContent + this.getForward() + this.viewMail.body_html;
			successMsg = "Draft saved successfully";
			pathAfterSuccess = "draft";
		} else if (action == "mail_reply_message") {
			mailObj["reply_id"] = this.viewMail.id;
			mailObj["email_status"] = "sent";
			mailObj["content"] = mailContent + this.getForward() + this.viewMail.body_html + disclaimer;
			successMsg = "Mail sent successfully";
			pathAfterSuccess = "outgoing";
		}
		if (this.viewMail.event_id) {
			mailObj.event_id = this.viewMail.event_id;
		}
		let totalSize = getStringSizeInBytes(mailObj["content"]);
		const att = JSON.parse(mailObj["attachment"]);
		for (let i = 0; i < att.length; i++) {
			if (!isNaN(att[i].size)) {
				totalSize += parseInt(att[i].size);
			}
		}
		let sizeInMB = totalSize / 1024 / 1024;
		if (sizeInMB >= maxMailSizeMB) {
			this.toastr.error("Mail size exceeds " + maxMailSizeMB + "MB", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.showMailLoader = true;
		this.apiService.saveMail(mailObj).subscribe({
			next: (data) => {
				this.showMailLoader = false;
				this.toastr.success(successMsg, 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				if (this.apptId) {
					this.router.navigate(['/app/appt-details', 'no', this.apptId, this.followUpId, 'mails']);
				} else {
					this.router.navigate(['/app/mailbox/folder', pathAfterSuccess]);
					/* if (this.folder == pathAfterSuccess) {
						this.mailListComp.refreshMails(true);
					} */
				}
				setTimeout(() => {
					this.apiService.sendCountChangeEvent();
				}, 100);
			}, error: (error) => {
				this.showMailLoader = false;
				if (typeof error.error == "string") {
					this.toastr.error(error.error, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				} else {
					this.toastr.error("Something went wrong.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			}
		});
	}

	getForward() {
		let to_email = '';
		if (this.viewMail.toMailArr && this.viewMail.toMailArr.length > 0) {
			for (let i = 0; i < this.viewMail.toMailArr.length; i++) {
				to_email += "<a href=\"mailto:" + this.viewMail.toMailArr[i] + "\">" + this.viewMail.toMailArr[i] + "</a>; \n";
			}
		}
		let cc_email = '';
		if (this.viewMail.ccArr && this.viewMail.ccArr.length > 0) {
			for (let i = 0; i < this.viewMail.ccArr.length; i++) {
				cc_email += "<a href=\"mailto:" + this.viewMail.ccArr[i] + "\">" + this.viewMail.ccArr[i] + "</a>; \n";
			}
			cc_email = "<strong>CC: " + cc_email + "<br /> \n";
		}
		let forward = '<span id="mailSeparator" style="display:none;"></span>&nbsp;</br><hr />' +
			"<p><strong>From: </strong><a href=\"mailto:" + this.viewMail.from_email + "\">" + (this.viewMail.from_name || this.viewMail.from_email) + "</a><br /> \n" +
			"<strong>Sent: </strong>" + this.viewMail.messageDate + "<br /> \n" +
			"<strong>TO: " + to_email + "</strong> <br /> \n" +
			cc_email +
			"<strong>Subject: </strong>" + this.viewMail.subject + "</p>";
		return forward;
	}

	closeMail() {
		this.router.navigate(['../'], { relativeTo: this.activeRoute });
	}

	encode(id: any) {
		try {
			return btoa(id);
		} catch (error) {
			return null;
		}
	}

	caseLoader = false;
	getCases() {
		if (this.viewMail.event_id && this.viewMail.event_id.length) {
			this.caseLoader = true;
			this.apiService.getMultipleCases(this.viewMail.event_id).subscribe({
				next: (data) => {
					this.caseLoader = false;
					this.viewMail.eventList = data;
					$("#caseListModal").modal("show");
				}, error: (error) => {
					this.caseLoader = false;
					this.toastr.error("Something went wrong.", 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
			});
		} else {
			this.toastr.error("Something went wrong.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	dtOptions!: Config;
	dataList: any = [];
	openTemplateModal() {
		$("#mailTemplateModal").modal("show");
		if (!this.dtOptions) {
			this.dtOptions = {
				pagingType: 'full_numbers',
				serverSide: true,
				processing: true,
				ordering: false,
				language: {
					searchPlaceholder: "Search",
					search: ""
				},
				layout: {
					topStart: ['pageLength'],
					topEnd: ['search'],
					bottomStart: ['info'],
					bottomEnd: ['paging']
				},
				ajax: (dataTablesParameters: any, callback) => {
					const data: any = {
						draw: dataTablesParameters.draw,
						start: dataTablesParameters.start,
						length: dataTablesParameters.length,
						searchVal: dataTablesParameters.search.value
					}
					this.apiService.getMailTemplate(data).subscribe({
						next: (response: any) => {
							console.log(response)
							this.dataList = response.data.map((m: any) => {
								m.enc_id = btoa(m.id.toString());
								return m;
							});
							callback({
								recordsTotal: response.recordsTotal,
								recordsFiltered: response.recordsFiltered,
								data: []
							});
						}, error: (error: any) => {
							if (error.status == 401) { return }
							this.toastr.error("Something went wrong.", 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
						}
					});
				}
			}
		}
	}

	viewTemplate(template: any) {
		Swal.fire({
			title: template.name,
			html: template.body,
			icon: 'info'
		});
	}

	copyTemplate(template: any) {
		let body: any = this.form.get('mail')?.value.body;
		if (body == null) {
			body = "";
		}
		this.form.get('mail')?.patchValue({ body: template.body + body });
		$("#mailTemplateModal").modal("hide");
		this.toastr.success("Copied to mail.", 'Success', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}
}